import ReplyIcon from "@mui/icons-material/Reply";
import { Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  setCesiumPopupPosition,
  setCesiumPreloadMeas,
  setCesiumState,
  setHoveredCesiumItem,
  setMapType,
  setSelectedCesiumItem,
  setSelectedPointcloud,
} from "~/redux/reducers/mapReducer";
import { useAppDispatch } from "~/redux/store/store";

const MainMapButton = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  return (
    <Button
      color="primary"
      variant="contained"
      startIcon={<ReplyIcon />}
      onClick={() => {
        dispatch(setMapType("2d"));
        dispatch(setCesiumState("unloaded"));
        dispatch(setSelectedCesiumItem(undefined));
        dispatch(setCesiumPopupPosition(undefined));
        dispatch(setHoveredCesiumItem(undefined));
        dispatch(setSelectedPointcloud(undefined));
        dispatch(setCesiumPreloadMeas(undefined));
      }}
    >
      {t("map:back-to-2d")}
    </Button>
  );
};

export default MainMapButton;
